import * as React from "react";
import {redirectToRiskcovry} from "InsuranceV2";
import {imageBaseUrl} from "config";
import "InsuranceV2/LandingPage/InsuranceBanner/styles.scss";

interface IInsuranceBanner {
    redirectLink: string;
}

const InsuranceBanner = (props: IInsuranceBanner) => {
    return (
        <div className="insurance-banner-container" onClick={() => redirectToRiskcovry(props.redirectLink)}>
            <img className="insurance-banner" src={`${imageBaseUrl}/insurance/banner/Insurance_banner.png`} />
        </div>
    );
};

export default InsuranceBanner;
